module.exports = __webpack_public_path__ + "img/menu.e459c26b.svg";